module.exports = __webpack_public_path__ + "img/email_header_img.c3de468a.png";